import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { GeometricField } from '../visuals/GeometricField';
type PageHeroProps = {
  kicker?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  crumbs?: {
    label: string;
    to?: string;
  }[];
  aside?: React.ReactNode;
};
export function PageHero({
  kicker,
  title,
  intro,
  actions,
  crumbs,
  aside
}: PageHeroProps) {
  return <section className="relative overflow-hidden bg-midnight text-white" data-id="element-527" data-mp="1cahynsv4h7ym">
      <GeometricField data-id="element-528" data-mp="17e1168219h8v" />
      <div className="container-page relative grid gap-12 py-16 md:py-24 lg:grid-cols-12 lg:items-center" data-id="element-529" data-mp="17bero2vl0ro0">
        <div className={aside ? 'lg:col-span-7' : 'lg:col-span-9'} data-id="element-530" data-mp="12g7y3nw113ct">
          {crumbs && <nav aria-label="Breadcrumb" className="mb-8" data-id="element-531" data-mp="xho8ndi859fp">
              <ol className="flex flex-wrap items-center gap-1.5 text-sm text-white/60" data-id="element-532" data-mp="3n5f5070pgmhr">
                <li data-id="element-533" data-mp="3i4hn7vjlxugs">
                  <Link to="/" className="transition-colors duration-150 hover:text-gold-300" data-id="element-534" data-mp="3i3zkqh6cqk0f">
                    Home
                  </Link>
                </li>
                {crumbs.map(c => <li key={c.label} className="flex items-center gap-1.5" data-id="element-535" data-mp="2y2bnvpbbxfmi">
                    <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-536" data-mp="2j4srq1wbo051" />
                    {c.to ? <Link to={c.to} className="transition-colors duration-150 hover:text-gold-300" data-id="element-537" data-mp="2o3cbbvng0zu8">
                        {c.label}
                      </Link> : <span aria-current="page" className="text-white/85" data-id="element-538" data-mp="2f50o83lsck6j">
                        {c.label}
                      </span>}
                  </li>)}
              </ol>
            </nav>}
          {kicker && <p className="mb-5 text-sm font-medium text-gold-300" data-id="element-539" data-mp="1rewmy2w2kwip">{kicker}</p>}
          <h1 className="font-display text-5xl font-semibold leading-[1.04] md:text-6xl lg:text-[68px]" data-id="element-540" data-mp="1rh0nqbyo9fer">{title}</h1>
          {intro && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/75" data-id="element-541" data-mp="1x98d15n0r2t">{intro}</p>}
          {actions && <div className="mt-9 flex flex-wrap gap-3" data-id="element-542" data-mp="3tbooeqfu7llo">{actions}</div>}
        </div>
        {aside && <div className="lg:col-span-5" data-id="element-543" data-mp="3ocu7ju1fk747">{aside}</div>}
      </div>
    </section>;
}